import {
  FontAwesome,
  FontAwesome5,
  Ionicons,
  MaterialIcons,
} from "@expo/vector-icons";
import React, { useState } from "react";
import {
  Dimensions,
  Text,
  View,
  Alert,
  TouchableOpacity,
  Platform,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import {
  Centered,
  ErrorMessage,
  Input,
  Row,
  StepHeader,
} from "../../../components/all";
import colors from "../../../constants/colors";
import { resetEmptyFields } from "../../../reducers/auth/register";
import { resetEmptyFields as resetProfileEmptyFields } from "../../../reducers/profile/profile";
import { isAssistant, isNurses } from "../../../constants/lov/professions";
import * as DocumentPicker from 'expo-document-picker';
import { uploadResume } from "../../../services/profile";
import * as WebBrowser from "expo-web-browser";

export default function Step5({
  setFocusedInput,
  focusedInput,
  setAllFields,
  setField,
  allFields,
  editProfile,
  editEducation,
  isEditLicense,
  isUploadResume,
  isWeb,
  currentStep,
}) {
  const dispatch = useDispatch();
  const [uploading, setUploading] = useState(false);
  const { errorFields } = useSelector(
    (state) => state[editProfile ? "profile" : "register"]
  );
  const { country: userCountry } = useSelector((state) => state.user);
  const currentCountry = allFields.country || userCountry || 'MY';
  
  // Helper functions for country-specific license placeholders
  const getMedicalLicensePlaceholder = (country) => {
    const placeholders = {
      'MY': 'MMC no. - xxxxxx',     // Malaysian Medical Council
      'SG': 'SMC no. - xxxxxx',     // Singapore Medical Council
      'PH': 'PRC no. - xxxxxx',     // Philippine Regulation Commission
      'ID': 'STR no. - xxxxxx'      // Surat Tanda Registrasi (Indonesia)
    };
    return placeholders[country] || 'Medical Registration no. - xxxxxx';
  };

  const getPracticeLicensePlaceholder = (country) => {
    const placeholders = {
      'MY': 'APC no. - xxxxx/xxxx',  // Annual Practicing Certificate
      'SG': 'PC no. - xxxxx/xxxx',   // Practicing Certificate
      'PH': 'PRC-ID no. - xxxxx/xxxx', // PRC ID number
      'ID': 'SIP no. - xxxxx/xxxx'   // Surat Izin Praktik
    };
    return placeholders[country] || 'Practice License no. - xxxxx/xxxx';
  };

  const getMedicalLicenseErrorMessage = (country) => {
    const messages = {
      'MY': 'Please enter a valid MMC number.',
      'SG': 'Please enter a valid SMC number.',
      'PH': 'Please enter a valid PRC number.',
      'ID': 'Please enter a valid STR number.'
    };
    return messages[country] || 'Please enter a valid medical registration number.';
  };

  const getPracticeLicenseErrorMessage = (country) => {
    const messages = {
      'MY': 'Please enter a valid APC number.',
      'SG': 'Please enter a valid PC number.',
      'PH': 'Please enter a valid PRC-ID number.',
      'ID': 'Please enter a valid SIP number.'
    };
    return messages[country] || 'Please enter a valid practice license number.';
  };
  let { education } = allFields;
  if (education === undefined) {
    education = [];
  }
  const years = Array.from({ length: 100 }, (v, k) => {
    let date = new Date().getFullYear() - k;
    return {
      label: date.toString(),
      value: date.toString(),
    };
  });

  const setErrorFields = () => {
    dispatch(editProfile ? resetProfileEmptyFields() : resetEmptyFields());
  };

  const setArrayField = (field, index, key, value) => {
    let temp = [...allFields[field]];
    temp[index] = {
      ...temp[index],
      [key]: value,
    };
    setAllFields({ ...allFields, [field]: temp });
  };

  const onAddEducation = () => {
    setErrorFields();
    setAllFields({
      ...allFields,
      education: [...allFields.education, ""],
    });
  };

  const onAddResume = async () => {
    const result = await DocumentPicker.getDocumentAsync({
      type: "application/pdf",
    });
    setUploading(true);
    console.log('res', result.assets[0].uri);
    if (result.assets[0].uri) {
      uploadResume(result.assets[0].uri).then((res) => {
        console.log('res', res);
        setAllFields({
          ...allFields,
          resume: res.data.data.resume_url,
        });
        setUploading(false);
      });
    } else {
      setUploading(false);
    }
  };

  const viewResume = () => {
    console.log('viewResume', allFields.resume);
    WebBrowser.openBrowserAsync(allFields.resume);
  };

  const onRemoveEducation = (index) => {
    Alert.alert(
      "Delete Education",
      "Are you sure you want to delete this education?",
      [
        {
          text: "Cancel",
          style: "cancel",
        },
        {
          text: "OK",
          onPress: () => {
            setErrorFields();
            let temp = [...allFields.education];
            temp.splice(index, 1);
            setAllFields({ ...allFields, education: temp });
          },
        },
      ]
    );
  };
  if (isWeb && currentStep !== 4) return <></>;

  const input = {
    education: "education",
    educationError: "educationError",
    mmc: "mmc",
    apc: "apc",
    nsr: "nsr",
    mmcError: "mmcError",
    apcError: "apcError",
    nsrError: "nsrError",
  };
  return (
    <View
      style={{
        width: Dimensions.get("window").width,
        marginTop: isEditLicense ? 0 : Platform.OS !== "android" ? -50 : 0,
      }}
    >
      {editEducation ? (
        <View
          style={{
            marginTop: 80,
          }}
        ></View>
      ) : null}
      {editProfile && !isEditLicense && !isUploadResume ? (
        <></>
      ) : (
        <StepHeader
          label={
            editEducation
              ? `Update Education`
              : isUploadResume
                ? `Upload Resume`
                : isEditLicense
                  ? `Update\nMedical License`
                  : `Medical License \n& Education`
          }
          icon={<FontAwesome name="user-md" size={24} color="black" />}
          subtitle={
            isUploadResume
              ? `Upload your professional resume in PDF format`
              : isEditLicense
                ? `Change your medical license numbers below`
                : `Include relevant certification, licenses and education`
          }
        />
      )}

      <Centered style={{ marginTop: 20 }}>
        {editEducation || isUploadResume ? null : (
          <>
            {isNurses(allFields.expertise) ||
              isAssistant(allFields.expertise) ? null : (
              <Input
                onChangeText={(val) => {
                  setField(input.mmc, val);
                }}
                value={allFields[input.mmc]}
                icon={
                  <FontAwesome5 name="address-card" size={16} color="grey" />
                }
                placeholder={getMedicalLicensePlaceholder(currentCountry)}
                containerStyle={{ width: "90%", marginTop: 24 }}
                onBlur={() => setFocusedInput(null)}
                onFocus={() => {
                  setErrorFields();
                  setFocusedInput(input.mmc);
                }}
                error={
                  errorFields.includes(input.mmc) ||
                  errorFields.includes(input.mmcError)
                }
                focused={focusedInput === input.mmc}
                maxLength={6}
                keyboardType="numeric"
              />
            )}
            {isAssistant(allFields.expertise) ? null : (
              <Input
                onChangeText={(val) => {
                  setField(input.apc, val);
                }}
                value={allFields[input.apc]}
                icon={<Ionicons name="medical" size={16} color="grey" />}
                placeholder={getPracticeLicensePlaceholder(currentCountry)}
                containerStyle={{ width: "90%", marginTop: 10 }}
                onBlur={() => setFocusedInput(null)}
                onFocus={() => {
                  setErrorFields();
                  setFocusedInput(input.apc);
                }}
                error={
                  errorFields.includes(input.apc) ||
                  errorFields.includes(input.apcError)
                }
                focused={focusedInput === input.apc}
                maxLength={11}
              />
            )}
            {allFields.isSpecialist && allFields.expertise !== 3 && (
              <Input
                onChangeText={(val) => {
                  setField(input.nsr, val);
                }}
                value={allFields[input.nsr]}
                icon={
                  <FontAwesome5 name="book-medical" size={16} color="grey" />
                }
                placeholder="NSR no."
                containerStyle={{ width: "90%", marginTop: 10 }}
                onBlur={() => setFocusedInput(null)}
                onFocus={() => {
                  setErrorFields();
                  setFocusedInput(input.nsr);
                }}
                error={
                  errorFields.includes(input.nsr) ||
                  errorFields.includes(input.nsrError)
                }
                focused={focusedInput === input.nsr}
                maxLength={6}
                keyboardType="numeric"
              />
            )}
          </>
        )}
        {!editProfile && !isUploadResume &&
          education?.map((item, index) => (
            <>
              <Row>
                <Input
                  onChangeText={(val) => {
                    setArrayField(input.education, index, "name", val);
                  }}
                  value={education[index]?.name || ""}
                  placeholder={
                    isAssistant(allFields.expertise) &&
                      allFields.expertise !== 7
                      ? "SRP/SPM/STPM"
                      : "Diploma/Degree/Master"
                  }
                  icon={<FontAwesome name="book" size={14} color="grey" />}
                  containerStyle={{
                    width: index === 0 ? "90%" : "80%",
                    marginTop: 10,
                  }}
                  onBlur={() => setFocusedInput(null)}
                  onFocus={() => {
                    setErrorFields();
                    setFocusedInput(input.education[index]);
                  }}
                  error={errorFields.includes(input.educationError)}
                  focused={focusedInput === input.education[index]}
                />
                {index === 0 ? null : (
                  <View
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      width: "10%",
                      marginTop: 14,
                    }}
                  >
                    <TouchableOpacity onPress={() => onRemoveEducation(index)}>
                      <MaterialIcons
                        name="highlight-remove"
                        size={18}
                        color={"rgba(0,0,0,0.5)"}
                      />
                    </TouchableOpacity>
                  </View>
                )}
              </Row>
              <Row>
                <Input
                  onChangeText={(val) => {
                    setArrayField(input.education, index, "school", val);
                  }}
                  value={education[index]?.school || ""}
                  placeholder={
                    isAssistant(allFields.expertise)
                      ? "High School"
                      : "University/College"
                  }
                  icon={
                    <FontAwesome name="university" size={14} color="grey" />
                  }
                  containerStyle={{ width: "63%", marginTop: 10 }}
                  onBlur={() => setFocusedInput(null)}
                  onFocus={() => {
                    setErrorFields();
                    setFocusedInput(input.education[index]);
                  }}
                  error={errorFields.includes(input.educationError)}
                  focused={focusedInput === input.education[index]}
                />
                <Input
                  isPicker
                  onChangeText={(val) => {
                    setArrayField(
                      input.education,
                      index,
                      "year",
                      val?.toString()
                    );
                  }}
                  value={education[index]?.year || ""}
                  placeholder="Year"
                  containerStyle={{
                    width: "25%",
                    marginTop: 10,
                    marginLeft: 10,
                  }}
                  onBlur={() => setFocusedInput(null)}
                  onFocus={() => {
                    setErrorFields();
                    setFocusedInput(input.state);
                  }}
                  error={errorFields.includes(input.educationError)}
                  focused={focusedInput === input.state}
                  pickerItems={years}
                />
              </Row>
            </>
          ))}

        {!isEditLicense && allFields.resume ? (
          <>
            <View style={{
              margin: 10,
              // marginLeft: 24,
              backgroundColor: "#f5f5f5",
              padding: 15,
              borderRadius: 10,
              width: "90%",
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <FontAwesome5 name="file-pdf" size={16} color={colors.primary} />
                <Text style={{ marginLeft: 10, color: colors.primary, fontWeight: 'bold' }}>
                  Applicant Resume
                </Text>
              </View>
              <View style={{ flexDirection: 'row' }}>
                <TouchableOpacity
                  onPress={viewResume}
                  style={{
                    backgroundColor: colors.primary,
                    paddingVertical: 8,
                    paddingHorizontal: 15,
                    borderRadius: 5,
                    marginRight: 10
                  }}
                >
                  <Text style={{ color: 'white' }}>View PDF</Text>
                </TouchableOpacity>

              </View>
            </View>
            <TouchableOpacity
              onPress={onAddResume}
              style={{
                backgroundColor: 'white',
                paddingVertical: 8,
                paddingHorizontal: 15,
                borderRadius: 5,
                borderWidth: 1,
                marginTop: 10,
                width: "90%",
                alignSelf: "center",
                borderWidth: 1,
                borderColor: "rgba(0,0,0,0.1)",
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FontAwesome5 name="file-upload" size={12} color={'rgba(0,0,0,0.5)'} />
              <Text style={{ color: 'rgba(0,0,0,0.5)', textAlign: 'center', marginLeft: 10 }}>{
                uploading ? 'Uploading...' : 'Replace Resume'
              }</Text>
            </TouchableOpacity>
          </>
        ) : !isEditLicense ? (
          <TouchableOpacity
            onPress={onAddResume}
            style={{
              backgroundColor: "rgba(0,0,0,0.05)",
              width: "90%",
              height: 150,
              marginTop: 10,
              borderRadius: 10,
              alignSelf: "center",
              justifyContent: "center",
              alignItems: "center",
              borderWidth: 2,
              borderColor: "rgba(0,0,0,0.1)",
              borderStyle: "dashed",
            }}>
            <View style={{ alignItems: 'center' }}>
              <FontAwesome5 name="file-upload" size={30} color={colors.primary} />
              <Text style={{ color: colors.primary, marginTop: 10, fontWeight: '500', fontSize: 16 }}>{uploading ? 'Uploading...' : 'Upload Resume'}</Text>
              <Text style={{ color: 'rgba(0,0,0,0.5)', marginTop: 5, fontSize: 12 }}>PDF format only</Text>
            </View>
          </TouchableOpacity>
        ) : null}
      </Centered>
      {!editProfile && !isUploadResume && (
        <View style={{ width: "100%", alignItems: "flex-end" }}>
          <TouchableOpacity onPress={onAddEducation}>
            <View>
              <Text
                style={{
                  color: colors.primary,
                  fontWeight: "bold",
                  padding: 10,
                  paddingRight: 24,
                }}
              >
                + add education
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      )}
      <View style={{ margin: 10, marginLeft: 24 }}>
        <ErrorMessage
          visible={
            errorFields.includes(input.mmc) ||
            errorFields.includes(input.apc) ||
            errorFields.includes(input.educationError)
          }
          label={"Please fill in the required fields."}
        />
        <ErrorMessage
          visible={errorFields.includes(input.mmcError)}
          label={getMedicalLicenseErrorMessage(currentCountry)}
        />
        <ErrorMessage
          visible={errorFields.includes(input.apcError)}
          label={getPracticeLicenseErrorMessage(currentCountry)}
        />
        <ErrorMessage
          visible={errorFields.includes(input.nsrError)}
          label={"Please enter a valid NSR number."}
        />
      </View>
    </View>
  );
}
